module.exports = __webpack_public_path__ + "img/dustman.0521567.jpg";